import RidePrice from './RidePrice';

export default RidePrice;



// WEBPACK FOOTER //
// ./src/ondemand/components/RidePrice/index.js